import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { AdPlacementCardPreview, AdPlacementCardPropTypes } from './ad-placement-card-preview';
import { getPlacementStyles } from './styles/ad-placement-preview';

export const AdPlacementPreviewPropTypes = {
  propTypes: {
    children: PropTypes.node,
    styleOverrides: PropTypes.shape({}),
    showHeaderImage: PropTypes.bool,
    headerImage: PropTypes.string,
    headerImageAlt: PropTypes.string,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    ...AdPlacementCardPropTypes.propTypes,
  },
  defaultProps: {
    children: null,
    styleOverrides: {},
    showHeaderImage: false,
    headerImage: '',
    headerImageAlt: '',
    ...AdPlacementCardPropTypes.defaultProps,
  },
};

export const AdPlacementPreview = (props) => {
  const {
    styleOverrides,
    children,
    showHeaderImage,
    headerImage,
    headerImageAlt,
    image,
    showImage,
  } = props;

  const isIncluded = showImage ? image && image.isIncluded : true;

  const classes = useDefaultStyles(getPlacementStyles({ styleOverrides, isIncluded }));

  const cardProps = _.pick(
    props,
    _.keys(AdPlacementCardPropTypes.propTypes)
  );

  return (
    <div className={classnames('ad-placement-preview', cardProps.className)}>
      <div className={classnames('new-responsive-ad-preview-container', classes.placementContainer)}>
        <div className={classnames('card-parent', classes.cardParent)}>
          {
            showHeaderImage &&
            <div className={classnames('header-image', classes.headerImage)}>
              <img src={headerImage} alt={headerImageAlt} />
            </div>
          }
          <AdPlacementCardPreview {...cardProps} />
        </div>
        {children}
      </div>
    </div>
  );
};

AdPlacementPreview.propTypes = {
  ...AdPlacementPreviewPropTypes.propTypes,
};

AdPlacementPreview.defaultProps = {
  ...AdPlacementPreviewPropTypes.defaultProps,
};
